export default __webpack_public_path__ + "static/media/bank.26689228.svg";